import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Modal from 'components/modal';
import Header from './header';
import LoadingSpinner from 'components/loading_spinner';
import Tabs from './tabs';
import { loadActivities } from 'bundles/apex/deals/show/store/activities/search/actions';
import { loadComments } from 'bundles/apex/deals/show/store/comments/actions';
import { loadDeal } from 'bundles/apex/deals/show/store/deal/actions';
import { loadFields } from 'bundles/apex/deals/show/store/fields/actions';

import './styles.scss';

export function ProjectDealsSidebar({
  deal,
  deals,
  loadActivities,
  loadComments,
  loadDeal,
  loadFields,
  show,
  onHide
}) {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (deals?.length && !deal) {
      const defDeal = deals.find(deal => deal.parent) || deals[0];
      loadSidebarDeal(defDeal);
    }
  }, [deals]);

  const changeDeal = (deal) => {
    loadSidebarDeal(deal);
  };

  const loadSidebarDeal = async (deal) => {
    setLoading(true);
    await Promise.all([
      loadDeal(`${deal.path}.json`),
      loadFields(deal.fieldsPath)
    ]);
    loadComments();
    loadActivities();
    setLoading(false);
  };

  return (
    <Modal asSidebar className="project-deals-sidebar" show={show} onHide={onHide}>
      <Modal.Header className="pt-4">
        <Header deals={deals} selectedDeal={deal} onDealChange={changeDeal} />
      </Modal.Header>
      <Modal.Body>
        {loading ? <LoadingSpinner /> : <Tabs />}
        <div aria-label="closeDealsSidebar" className="project-deals-sidebar-pulltab" onClick={onHide}>
          <FontAwesomeIcon icon={faCaretDown}/>
        </div>
      </Modal.Body>
    </Modal>
  );
}

ProjectDealsSidebar.propTypes = {
  deal: PropTypes.object,
  deals: PropTypes.arrayOf(PropTypes.object),
  loadActivities: PropTypes.func.isRequired,
  loadComments: PropTypes.func.isRequired,
  loadDeal: PropTypes.func.isRequired,
  loadFields: PropTypes.func.isRequired,
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

const mapDispatchToProps = {
  loadActivities,
  loadComments,
  loadDeal,
  loadFields,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectDealsSidebar);
